module.exports = __webpack_public_path__ + "static/media/tableImage.e605a169.svg";